import { useState } from "react";
import { Settings, Loader2 } from "lucide-react";
import { useProState } from "../lib/pro";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ManageProButton({ className = "" }) {
  const { email } = useProState();
  const [loading, setLoading] = useState(false);

  const onClick = async () => {
    if (!email) {
      toast.error("No subscriber email on this device");
      return;
    }
    setLoading(true);
    try {
      const res = await fetch(`${API}/billing/portal`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, return_url: window.location.origin + "/dashboard" }),
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.detail || "Could not open the billing portal");
      }
      const data = await res.json();
      if (!data.url) throw new Error("No portal URL returned");
      window.location.href = data.url;
    } catch (err) {
      toast.error(err.message || "Could not open the billing portal");
      setLoading(false);
    }
  };

  return (
    <button
      onClick={onClick}
      disabled={loading}
      data-testid="manage-pro-btn"
      className={`inline-flex items-center justify-center gap-1.5 rounded-full px-4 py-2 text-sm font-medium transition-all active:scale-[0.97] border border-brand-gold/40 text-brand-gold hover:bg-brand-gold/10 disabled:opacity-60 disabled:cursor-not-allowed ${className}`}
    >
      {loading ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Settings className="w-3.5 h-3.5" strokeWidth={2.25} />}
      Manage Pro
    </button>
  );
}
